module.exports = __webpack_public_path__ + "img/carshina22_16.6fd15ded.jpg";